




























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import { FILTERS_GETTER_TYPES } from '@/platform/store/filters/filters.getter.types';

import EmpathyNow from '@empathybroker/empathy-now';

import { deepMerge } from '@empathybroker/deep-merge';

import DataProvider from './DataProvider';
import OptionsProvider, { NowOptions } from './OptionsProvider';

import Sortable from 'sortablejs';

@Component({
  computed: {
    ...mapGetters({
      filtersSelectedValues: FILTERS_GETTER_TYPES.selectedValues,
      filtersAreValid: FILTERS_GETTER_TYPES.areValid
    })
  }
})
export default class NowQueryWrapperComponent extends Vue {

  private filtersAreValid: boolean;

  private fetchDataInterval;

  private globalEvents = ['total_queries', 'queries', 'clicks', 'no_results'];
  private sortedEvents = this.globalEvents.slice(1);

  private visualizationElement: HTMLElement;
  private visualization: EmpathyNow;
  private visualizationOptions: any = {};
  private visualizationDataProvider = new DataProvider();

  private currentData: any = null;

  private isMobileLayout = (window.innerWidth < 1024);

  @Watch('filtersSelectedValues', { deep: true })
  private onFiltersSelectedValuesChange(): void {
    this.fetchData();
  }

  protected mounted(): void {
    this.$emit('update:floatingTopBar', true);

    this.visualizationElement = (this.$refs.visualizationElement as HTMLElement);
    this.visualizationOptions = this.getVisualizationOptions();

    this.fetchData();
    this.fetchDataInterval = setInterval((): void => {
      if (document.visibilityState === 'visible') {
        this.fetchData(false);
      }
    }, 30000);

    Sortable.create(this.$refs.controlsContainerElement, {
      handle: '.now-query-wrapper__control__handle',
      animation: 500,
      ghostClass: 'now-query-wrapper__control--ghost',
      onUpdate: (ev) => {
        const movedEvent = this.sortedEvents.splice(ev.oldIndex, 1)[0];
        this.sortedEvents.splice(ev.newIndex, 0, movedEvent);
        this.sortSelectedEvents();

        this.renderVisualization();
      }
    });
  }

  protected beforeDestroy(): void {
    clearInterval(this.fetchDataInterval);

    this.visualization.destroy();
  }

  private getEventName(event: string): string {
    return {
      'total_queries': 'Total queries',
      'queries': 'Result queries',
      'clicks': 'Clicks',
      'no_results': 'No results'
    }[event];
  }

  private getEventValueString(event: string): string {
    return this.getEventValue(event).toLocaleString();
  }

  private getEventValue(event: string): number {
    let eventValue = 0;
    eventValue = {
      'total_queries': (this.currentData.stats.query_count + this.currentData.stats.no_results_count),
      'queries': this.currentData.stats.query_count,
      'clicks': this.currentData.stats.click_count,
      'no_results': this.currentData.stats.no_results_count
    }[event];
    return eventValue;
  }

  private getEventPercentage(event: string): number {
    let eventPercentage = 0;
    const queryCount = this.getEventValue('total_queries');
    if (queryCount > 0) {
      eventPercentage = ((this.getEventValue(event) / queryCount) * 100);
    }
    return eventPercentage;
  }

  private getEventPercentageString(event: string): string {
    return `${this.getEventPercentage(event).toLocaleString().slice(0, 4)}%`;
  }

  private get selectedEvents(): string[] {
    if (!!this.visualizationOptions.events) {
      return this.visualizationOptions.events;
    }
    if (this.isMobileLayout) {
      return [this.sortedEvents[0]];
    }
    return this.sortedEvents.slice();
  }

  private fetchData(filtersHaveChanged = true): void {
    if (!this.filtersAreValid) {
      return;
    }

    if (filtersHaveChanged) {
      this.$emit('update:loading', true);
    }

    this.visualizationDataProvider.getData()
      .then((dataResponse: any) => {
        if (filtersHaveChanged) {
          this.currentData = dataResponse;
        } else {
          this.currentData.stats = dataResponse.stats;
          this.currentData.trends =
            this.visualizationDataProvider.mergeData(this.currentData.trends, dataResponse.trends, this.visualizationOptions);
        }
        this.renderVisualization(filtersHaveChanged);

        this.$emit('update:loading', false);
      })
      .catch(() => {
        this.$emit('update:loading', false);
      });
  }

  private renderVisualization(initializeVisualization = false): void {
    if (!this.visualization || initializeVisualization) {
      this.visualization = new EmpathyNow(this.visualizationElement, this.visualizationOptions, this.getTrimmedData());
    } else {
      this.visualization.setData(this.getTrimmedData(), this.visualizationOptions);
    }
  }

  private getVisualizationOptions(): any {
    const visualizationOptions = new OptionsProvider(undefined, this.visualizationElement).get();
    visualizationOptions.events = this.selectedEvents;
    return visualizationOptions;
  }

  private getTrimmedData(): any {
    const trimmedData = deepMerge({}, this.currentData);
    this.visualizationOptions.events.forEach((event: string, index: number): void => {
      if (trimmedData.trends[event]) {
        trimmedData.trends[event] = trimmedData.trends[event]
          .filter((trend: any) => trend.query.length > 1)
          .slice(0, (index === 0 ? this.visualizationOptions.nodes.main : this.visualizationOptions.nodes.secondary));
      }
    });
    return trimmedData;
  }

  private onControlClick(ev: any): void {
    const event = ev.srcElement.getAttribute('event');
    if (!!event) {
      const indexOfEvent = this.visualizationOptions.events.indexOf(event);
      if (indexOfEvent >= 0) {
        if (this.visualizationOptions.events.length === 1) {
          return;
        }
        this.visualizationOptions.events.splice(indexOfEvent, 1);
      } else {
        if (this.isMobileLayout) {
          this.visualizationOptions.events = [event];
        } else {
          this.visualizationOptions.events.push(event);
          this.sortSelectedEvents();
        }
      }
      this.renderVisualization();
    }
  }

  private sortSelectedEvents(): void {
    this.selectedEvents.sort((ev1: string, ev2: string) => (this.sortedEvents.indexOf(ev1) - this.sortedEvents.indexOf(ev2)));
  }

}




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/insights/components/catalog/now_query/now_query-wrapper.component.vue